import {addI18Keysets} from '../../../i18n';

import dicts from './dicts';

export default addI18Keysets('yt:accounts-utils', dicts);
